import React, { RefObject } from "react";
import { heroImage } from "../../data/films";
interface HeroSceneProps {
  videoRef: RefObject<HTMLVideoElement>;
  onLoadedMetadata: () => void;
}
export function HeroScene({
  videoRef,
  onLoadedMetadata
}: HeroSceneProps) {
  if (!heroImage.videoSrc) {
    return <img src={heroImage.src} alt={heroImage.alt} className="absolute inset-0 h-full w-full object-cover object-[60%_50%]" data-id="element-138" data-mp="wvvhm3av2q6f" />;
  }
  return <video ref={videoRef} src={heroImage.videoSrc} poster={heroImage.src} muted playsInline preload="auto" onLoadedMetadata={onLoadedMetadata} aria-label={heroImage.alt} className="absolute inset-0 h-full w-full object-cover object-[60%_50%]" data-id="element-139" data-mp="j3oyc8cew32r" />;
}